import { useUiStore } from '../store/ui.js';

// Wraps the brand SVG. Swaps between light + dark lockup based
// on the current theme so the logo stays legible against the
// app background. Falls back to the icon-only mark when the
// `compact` prop is set (used in the collapsed sidebar).

interface Props {
  compact?: boolean;
  height?: number;
  className?: string;
}

export function ShiftinLogo({ compact = false, height, className }: Props) {
  const theme = useUiStore((s) => s.theme);
  const src = compact
    ? '/brand/shiftin-icon.svg'
    : theme === 'dark'
      ? '/brand/shiftin-logo-dark.svg'
      : '/brand/shiftin-logo-light.svg';
  return (
    <img
      src={src}
      alt="SHIFTIN"
      height={height ?? (compact ? 32 : 28)}
      className={className}
      draggable={false}
    />
  );
}
